const features = [
  {
    icon: 'ri-search-eye-line',
    title: '独家深扒',
    desc: '独立调查团队深入挖掘，还原事件来龙去脉与背后真相，每篇深扒文章都经过多源交叉验证。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '实时速报',
    desc: '全网7×24小时监控娱乐圈动态，热点事件第一时间整理推送，让你永远走在吃瓜最前线。',
  },
  {
    icon: 'ri-archive-line',
    title: '海量存档',
    desc: '黑历史数据库持续积累，按人物、事件、时间线分类归档，随时查阅复盘过往大瓜。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">为什么选择每日大瓜</h2>
          <p className="mt-2 text-sm text-foreground-500">专业吃瓜，从这里开始</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}